export default import.meta.ROLLUP_FILE_URL_h7hW0KXs6cdvDYm2fpZDbQ